import safeParseUrl from '../../utils/url/safeParseUrl';

const SLAB_REGEX = new RegExp(
  `^/(drafts|posts|users|topics|groups)/(?:[^#]*-)?([a-z0-9]+)/?$`,
);

export default function matchEntityLink(link: string): {
  id: string;
  type: 'user' | 'topic' | 'group' | 'post';
  params?: string;
} | null {
  const url = safeParseUrl(link);
  if (!url || url.host !== document.location.host) {
    return null;
  }

  const queryString = url.searchParams.toString();
  const params = queryString ? `?${queryString}` : undefined;
  const [path, id] = url.pathname.match(SLAB_REGEX)?.slice(1) ?? [];

  const combinedId = id ? `${id}${url.hash}` : id;
  if (combinedId) {
    switch (path) {
      case 'users':
        return { id: combinedId, type: 'user', params };
      case 'topics':
        return { id: combinedId, type: 'topic', params };
      case 'groups':
        return { id: combinedId, type: 'group', params };
      default:
        return { id: combinedId, type: 'post', params };
    }
  }

  return null;
}
